import React from "react";
import Select from "react-select";
import "./MultiSelectInput.css"
import CustomError from "../Errors/CustomError";
import Asterisks from "../Asterisks/Asterisks";

const MultiSelectInput = ({
  label,
  options,
  value,
  onMultiSelect,
  noDataMessage = "no data..",
  maxMenuHeight = 200,
  isClearable = false,
  placeholder = "Select",
  parentClassName = "",
  selectClassName = "",
  labelClassName = "",
  parentStyle = {},
  selectStyle = {},
  labelStyle = {},
  customError,
  asterisk,
}) => {
  // const flattenedOptions =
  //   options &&
  //   options?.reduce((acc, item) => {
  //     return acc.concat(
  //       { value: "select-all", label: "Select All" },
  //       item.options
  //     );
  //   }, []);

  return (
    <div
      className={
        parentClassName && parentClassName.trim() !== ""
          ? parentClassName
          : "default-multi-select-parent-class"
      }
      style={parentStyle}>
      <label
        className={
          labelClassName && labelClassName.trim() !== ""
            ? labelClassName
            : "default-multi-select-label-class"
        }
        style={labelStyle}>
        {label} <Asterisks asterisk={asterisk} />
      </label>
      <div className="input-wrapper">
        <Select
          value={value}
          onChange={onMultiSelect}
          options={options}
          classNamePrefix="select2-selection"
          placeholder={placeholder}
          className={selectClassName}
          styles={{
            ...selectStyle,
            control: (provided, state) => ({
              ...provided,
              borderColor: customError
                ? "#d15757"
                : state.isFocused
                ? "blue"
                : "#ccc",
              boxShadow: customError
                ? "0 0 3px rgba(255, 0, 0, 0.5) "
                : state.isFocused
                ? "0 0 0 1px blue"
                : "none",
              "&:hover": {
                borderColor: customError
                  ? "#d15757"
                  : state.isFocused
                  ? "blue"
                  : "#ccc",
              },
            }),
            menu: (provided) => ({
              ...provided,
              borderColor: "#ccc",
            }),
            option: (provided, state) => ({
              ...provided,

              padding: "10px",
              margin: "2px 8px",
              width: "calc(100% - 16px)",
              boxSizing: "border-box",
            }),
            valueContainer: (base) => ({
              ...base,
              maxHeight: "62px",
              overflowY: "auto",
              overflowX: "auto",
              display: "flex",
              flexWrap: "wrap",
            }),
             placeholder: (provided) => ({
              ...provided,
              textTransform: "capitalize", 
            }),
          }}
          menuPortalTarget={document.body}
          noOptionsMessage={() => noDataMessage}
          maxMenuHeight={maxMenuHeight}
          isClearable={isClearable}
          isMulti
        />

        {customError && (
          <i className="fas fa-exclamation-circle error-icon"></i>
        )}
      </div>
      {customError && <CustomError error={customError} />}
    </div>
  );
};

export default MultiSelectInput;
